module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_2_2.389eec88.png";